<template>
  <div class="system-message-manager">
    <div class="page-header">
      <span class="page-title">系统消息</span>
      <el-button type="primary" size="small" @click="openDialog()">新增消息</el-button>
    </div>

    <div class="search-bar">
      <el-input v-model="query.search" clearable placeholder="请输入标题或内容" class="search-input" @keyup.enter.native="loadList" />
      <el-select v-model="query.level" clearable placeholder="级别" class="search-select">
        <el-option label="普通" value="NORMAL" />
        <el-option label="重要" value="IMPORTANT" />
        <el-option label="警告" value="WARNING" />
      </el-select>
      <el-select v-model="query.status" clearable placeholder="状态" class="search-select">
        <el-option label="草稿" :value="0" />
        <el-option label="已发布" :value="1" />
        <el-option label="已下架" :value="2" />
      </el-select>
      <el-button type="primary" size="small" @click="loadList">查询</el-button>
    </div>

    <el-table :data="tableData" border stripe>
      <el-table-column prop="title" label="标题" min-width="180" show-overflow-tooltip />
      <el-table-column label="级别" width="90">
        <template slot-scope="scope">{{ levelName(scope.row.level) }}</template>
      </el-table-column>
      <el-table-column label="范围" width="110">
        <template slot-scope="scope">{{ scope.row.audienceType === 'TENANT' ? '指定租户' : '全部租户' }}</template>
      </el-table-column>
      <el-table-column label="状态" width="90">
        <template slot-scope="scope">
          <el-tag size="mini" :type="statusType(scope.row.status)">{{ statusName(scope.row.status) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" label="创建人" width="110" />
      <el-table-column prop="gmtCreate" label="创建时间" width="160" />
      <el-table-column label="操作" width="280" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openDialog(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status !== 1" type="text" size="small" @click="publishRow(scope.row)">发布</el-button>
          <el-button v-if="scope.row.status === 1" type="text" size="small" @click="unpublishRow(scope.row)">下架</el-button>
          <el-button type="text" size="small" class="danger-text" @click="deleteRow(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, prev, pager, next, sizes"
        :current-page="query.curPage"
        :page-size="query.limit"
        :total="total"
        @current-change="pageChange"
        @size-change="sizeChange" />
    </div>

    <el-dialog :title="form.id ? '编辑系统消息' : '新增系统消息'" :visible.sync="dialogVisible" width="680px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="标题" prop="title"><el-input v-model="form.title" maxlength="100" show-word-limit /></el-form-item>
        <el-form-item label="级别">
          <el-select v-model="form.level" style="width: 100%">
            <el-option label="普通" value="NORMAL" />
            <el-option label="重要" value="IMPORTANT" />
            <el-option label="警告" value="WARNING" />
          </el-select>
        </el-form-item>
        <el-form-item label="发布范围">
          <el-radio-group v-model="form.audienceType">
            <el-radio label="ALL">全部租户</el-radio>
            <el-radio label="TENANT">指定租户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="form.audienceType === 'TENANT'" label="指定厂商" prop="targetTenantKeys">
          <el-select
            v-model="form.targetTenantKeys"
            multiple
            filterable
            placeholder="请选择厂商"
            style="width: 100%"
            :loading="tenantOptionsLoading">
            <el-option
              v-for="item in tenantOptions"
              :key="item.dbName"
              :label="item.name"
              :value="item.dbName" />
          </el-select>
        </el-form-item>
        <el-form-item label="内容" prop="content"><el-input v-model="form.content" type="textarea" :rows="8" /></el-form-item>
        <el-form-item label="失效时间">
          <el-date-picker v-model="form.expireTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="不填写表示长期有效" style="width: 100%" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listSystemMessage,
  saveSystemMessage,
  updateSystemMessage,
  publishSystemMessage,
  unpublishSystemMessage,
  deleteSystemMessage
} from '@/api/systemMessage'

const defaultForm = () => ({
  id: null,
  title: '',
  content: '',
  level: 'NORMAL',
  audienceType: 'ALL',
  status: 0,
  expireTime: '',
  targetTenantKeys: []
})

export default {
  name: 'SystemMessageManager',
  data() {
    return {
      query: { search: '', level: '', status: '', curPage: 1, limit: 10 },
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: defaultForm(),
      tenantOptions: [],
      tenantOptionsLoading: false,
      rules: {
        title: [{ required: true, message: '请填写标题', trigger: 'blur' }],
        content: [{ required: true, message: '请填写内容', trigger: 'blur' }],
        targetTenantKeys: [{
          validator: (rule, value, callback) => {
            if (this.form.audienceType === 'TENANT' && (!value || value.length === 0)) {
              callback(new Error('请至少选择一个厂商'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }]
      }
    }
  },
  mounted() {
    this.loadList()
    this.loadTenantOptions()
  },
  methods: {
    async loadList() {
      const params = Object.assign({}, this.query)
      Object.keys(params).forEach(key => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) delete params[key]
      })
      const res = await listSystemMessage(params)
      const body = res.body || {}
      this.tableData = Array.isArray(body.data) ? body.data : []
      this.total = Number(body.cum || this.tableData.length || 0)
    },
    pageChange(page) {
      this.query.curPage = page
      this.loadList()
    },
    sizeChange(size) {
      this.query.limit = size
      this.query.curPage = 1
      this.loadList()
    },
    async loadTenantOptions() {
      this.tenantOptionsLoading = true
      try {
        const res = await this.componentsMoudel.startPost('/mainManager/list_all', { limit: 10000, curPage: 1, name: '' }, false)
        const list = (res && res.body && res.body.data) || []
        this.tenantOptions = list
          .filter(item => item.dbName)
          .map(item => ({ dbName: item.dbName, name: item.name }))
      } catch (e) {
        // 厂商列表加载失败不应阻塞消息编辑
      } finally {
        this.tenantOptionsLoading = false
      }
    },
    openDialog(row) {
      this.form = row ? Object.assign(defaultForm(), row, {
        targetTenantKeys: Array.isArray(row.targetTenantKeys) ? row.targetTenantKeys.slice() : []
      }) : defaultForm()
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        const params = Object.assign({}, this.form, {
          targetTenantKeys: this.form.audienceType === 'TENANT' ? this.form.targetTenantKeys : []
        })
        try {
          if (params.id) {
            await updateSystemMessage(params)
            this.$message.success('修改成功')
          } else {
            delete params.id
            await saveSystemMessage(params)
            this.$message.success('保存成功')
          }
          this.dialogVisible = false
          this.loadList()
        } catch (e) {}
      })
    },
    publishRow(row) {
      this.$confirm('确认发布这条系统消息吗？', '提示', { type: 'warning' }).then(async () => {
        await publishSystemMessage(row.id)
        this.$message.success('发布成功')
        this.loadList()
      }).catch(() => {})
    },
    unpublishRow(row) {
      this.$confirm('确认下架这条系统消息吗？', '提示', { type: 'warning' }).then(async () => {
        await unpublishSystemMessage(row.id)
        this.$message.success('下架成功')
        this.loadList()
      }).catch(() => {})
    },
    deleteRow(row) {
      this.$confirm('确认删除这条系统消息吗？', '提示', { type: 'warning' }).then(async () => {
        await deleteSystemMessage(row.id)
        this.$message.success('删除成功')
        this.loadList()
      }).catch(() => {})
    },
    levelName(value) {
      return value === 'IMPORTANT' ? '重要' : value === 'WARNING' ? '警告' : '普通'
    },
    statusName(value) {
      return value === 1 ? '已发布' : value === 2 ? '已下架' : '草稿'
    },
    statusType(value) {
      return value === 1 ? 'success' : value === 2 ? 'info' : 'warning'
    }
  }
}
</script>

<style scoped>
.system-message-manager {
  padding: 20px 24px;
  background: #fff;
  min-height: calc(100vh - 56px);
}
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.page-title {
  font-size: 18px;
  font-weight: 600;
}
.search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}
.search-input {
  width: 280px;
  margin-right: 10px;
}
.search-select {
  width: 130px;
  margin-right: 10px;
}
.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
.danger-text {
  color: #f56c6c;
}
</style>
